import { render, staticRenderFns } from "./EditOrderButton.vue?vue&type=template&id=9539f666&scoped=true"
import script from "./EditOrderButton.vue?vue&type=script&lang=js"
export * from "./EditOrderButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9539f666",
  null
  
)

export default component.exports